<!-- 库存管理 -->
<template>
  <div class="container">
    <div style="padding:10px 20px">
      <div class="t_header">
        <div style="display:flex">
          <div style="display:flex;margin-right:10px" v-if="s_show">
            <el-input
              v-model="search"
              prefix-icon="el-icon-search"
              clearable
              style="border-radius:4px;width:400px;margin-right:10px"
              placeholder="输入关键字搜索"
            />
            <el-button @click="searchEnterFun()" type="primary"
              ><i class="el-icon-search"></i>搜索</el-button
            >
          </div>
          <el-button
            @click="exportClientInfoExcel"
            :type="defaultColr"
            :disabled="btnStatu"
            size="medium"
            v-if="e_show"
            ><i class="el-icon-download"></i>导出</el-button
          >
          <el-button
            @click="exportAllExcel"
            type="primary"
            size="medium"
            v-if="e_show"
            >一键导出</el-button
          >
          <el-button
            @click="loseData"
            :type="defaultColr"
            :disabled="btnStatu"
            v-if="b_show"
            >拆解</el-button
          >
          <el-button
            @click="updateParameter"
            type="primary"
            v-if="u_show"
            >批量参数修改</el-button
          >
          <el-button
            @click="updateQrCode"
            type="primary"
            v-if="q_show"
            >二维码修改</el-button
          >
          <el-button @click="searchMore" type="primary"
            ><i class="el-icon-search"></i>更多搜索</el-button
          >
        </div>
        <div style="display:flex">
          <div style="margin-right: 10px;">
            <span style="margin-right: 10px;">账号</span>
            <el-select
              v-model="a_acount"
              placeholder="请选择"
              @change="acountChange"
            >
              <el-option
                v-for="item in acounts"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <el-table
        ref="filterTable"
        :data="tableData"
        @filter-change="fnFilterChangeInit"
        @selection-change="selectionChangeHandle"
        :header-cell-class-name="handleTheadAddClass"
        @sort-change="sortChange"
        :row-key="getRowKey"
        :header-cell-style="{
          fontSize: '15px',
          color: '#000',
          fontWeight: 800,
          background: '#eef1f6',
          padding: '4px'
        }"
        border
        height="700"
        :cell-style="{ padding: '2px' }"
        v-loading="loading"
      >
        <el-table-column
          type="selection"
          width="60"
          align="center"
          fixed
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column
          type="index"
          width="60"
          align="center"
          label="序号"
          fixed
        >
        </el-table-column>
        <el-table-column
          prop="materialType"
          label="产品类别"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="materialSeries"
          label="产品系列"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="materialCode"
          label="产品编号"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="materialModel"
          label="产品型号"
          align="center"
          width="120"
          :filter-multiple="false"
          :filters="materialModelGroup"
          :filter-method="filterTag"
          column-key="p_model"
          filter-placement="bottom-end"
        >
        </el-table-column>
        <el-table-column
          prop="productNo"
          label="序列号 "
          :sortable="true"
          align="center"
          width="240"
        >
        </el-table-column>
        <el-table-column
          prop="batchNo"
          label="产品批号 "
          :sortable="true"
          align="center"
          width="240"
        >
        </el-table-column>
        <el-table-column prop="spec" label="规格 " align="center" width="60">
        </el-table-column>
        <el-table-column
          prop="produceDate"
          label="生产日期 "
          align="center"
          width="120"
        >
        </el-table-column>

        <el-table-column
          prop="expiryDate"
          label="失效日期"
          align="center"
          width="120"
        >
        </el-table-column>

        <el-table-column prop="scrapStatus" label="状态" align="center" width="120" >
          <template slot-scope="scope">
              <span v-if="scope.row.scrapStatus != 0 && (Date.parse(scope.row.expiryDate) - new Date().getTime() >= 31536000000)">有效</span>
              <span style="color:#FFCC66" v-else-if="scope.row.scrapStatus != 0 && (Date.parse(scope.row.expiryDate) - new Date().getTime() < 31536000000 &&  Date.parse(scope.row.expiryDate) - new Date().getTime() >= 86400000)">预警</span>
              <span style="color:red" v-else-if="scope.row.scrapStatus != 0 && Date.parse(scope.row.expiryDate) - new Date().getTime() < 86400000">过期</span>
              <span style="color:red" v-else-if="scope.row.scrapStatus == 0">--报废--</span>
            </template>
          </el-table-column>
        <el-table-column
          prop="cartonCode"
          label="箱码"
          :sortable="true"
          align="center"
          width="240"
        >
        </el-table-column>
        <el-table-column
          prop="activateCode"
          label="激活码"
          :sortable="true"
          align="center"
          width="240"
        ></el-table-column>

        <el-table-column
          prop="instockTime"
          label="入库时间"
          align="center"
          :sortable="true"
          width="240"
        ></el-table-column>
        <el-table-column
          prop="producer"
          label="生产厂家"
          align="center"
          width="300"
        >
        </el-table-column>
        <el-table-column label="操作" align="center"  width="120">
          <template slot-scope="scope">
            <span v-if="b_show" class="loseContro" @click="loseContro(scope.row)">拆解</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span v-if="y_show" class="loseContro" @click="scrap(scope.row)">报废 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span v-if="x_show" class="loseContro" @click="recovery(scope.row)">恢复</span>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :currentPage="currentPage"
        :total="total"
        :limit="limit"
        :small="true"
        :numberSize="numberSize"
        @handleCurrentChange="handleCurrentChange"
      />
      <el-dialog
        title="拆解编码"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        center
        top="35vh"
        width="620px"
      >
        <div style="text-align:center">
          <p style="padding:0 0 45px 0">确定拆解编码，数据将无法找回！</p>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="breakPro">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="报废提醒"
        :visible.sync="scrapDialogVisible"
        :before-close="scrapDialogClose"
        center
        top="35vh"
        width="620px"
      >
        <div style="text-align:center">
          <p style="padding:0 0 45px 0">请确认是否报废？</p>
          <el-button @click="scrapDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="twoScrap()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="报废提醒"
        :visible.sync="twoScrapDialogVisible"
        :before-close="twoScrapDialogClose"
        center
        top="35vh"
        width="620px"
      >
        <div style="text-align:center">
          <p style="padding:0 0 45px 0">产品报废后将无法恢复使用，请再次确认是否报废？</p>
          <el-button @click="twoScrapDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="execScrap(100)">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="恢复库存"
        :visible.sync="recoveryDialogVisible"
        :before-close="recoveryDialogClose"
        center
        top="35vh"
        width="620px"
      >
        <div style="text-align:center">
          <p style="padding:0 0 45px 0">确定恢复库存吗？</p>
          <el-button @click="recoveryDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="execRecovery">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="搜索"
        :visible.sync="newDialogSearch"
        center
        width="620px"
        @close="formClose"
      >
        <searchForm @childDoFn="parentDoFun" />
      </el-dialog>
      <el-dialog
        title="参数修改"
        :visible.sync="updateParameterDialog"
        center
        width="680px"
        @close="formClose"
      >
        <el-form ref="updateForm" :model="uform" label-width="140px">
          <el-form-item label="需要修改的序列号">
            <div style="display:flex">
              <el-input v-model="uform.productNoStart"></el-input>
              <el-col :span="2" class="line">-</el-col>
              <el-input v-model="uform.productNoEnd"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="修改后的产品批号">
            <el-input v-model="uform.batchNo" style="width: 48%;"></el-input>
          </el-form-item>
          <el-form-item label="修改后的产品型号">
            <el-input v-model="uform.materialModel" style="width: 48%;"></el-input>
          </el-form-item>
          <el-form-item label="修改后的生产时间">
            <el-col :span="11">
              <el-date-picker
                placeholder="选择开始日期"
                v-model="uform.produceDate"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="修改后的失效时间">
            <el-col :span="11">
              <el-date-picker
                placeholder="选择失效日期"
                v-model="uform.expiryDate"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item class="buttonGroup">
            <el-button @click="clearUpdateDialog">清空</el-button>
            <el-button type="primary" @click="sureUpdateParameter">确定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <el-dialog
        title="二维码修改"
        :visible.sync="updateQrcodeDialog"
        center
        width="520px"
        @close="formClose"
      >
        <el-form ref="updateForm" :model="uform" label-width="140px">
          <el-form-item label="产品序列号">
            <el-input v-model="qform.productNo" style="width: 70%;"></el-input>
          </el-form-item>
          <el-form-item label="修改后的二维码">
            <el-input v-model="qform.newServeCode" style="width: 70%;"></el-input>
          </el-form-item>
          <el-form-item class="buttonGroup">
            <el-button @click="clearUpdateQrCodeDialog">清空</el-button>
            <el-button type="primary" @click="sureUpdateQrCode">确定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    <el-dialog
      title="错误提示"
      :visible.sync="errorVisible"
      width="400px"
      :before-close="handleClose"
    >
      <span>{{ infoTitle }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="errorVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pagination from '../components/Pagenation'
import searchForm from '../components/SearchForm'
import searchParent from '../services/search'
import axios from 'axios'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: { pagination, searchForm },
  data() {
    // 这里存放数据
    return {
      currentPage: 1,
      limit: 100,
      total: 0,
      numberSize: 0,
      materialModelGroup: [],
      tableData: [],
      search: '',
      tableDataSelections: [],
      dialogVisible: false,
      scrapDialogVisible: false,
      twoScrapDialogVisible: false,
      recoveryDialogVisible: false,
      getId: 0,
      acounts: [],
      a_acount: '',
      btnShow: true,
      defaultColr: 'info',
      btnStatu: true,
      s_show: false,
      b_show: false,
      e_show: false,
      u_show: false,
      q_show: false,
      x_show: false,
      y_show: false,
      loading: true,
      currentRow: null,
      orderStatu: '',
      keyName: '',
      keyStatu: '',
      mark: 0,
      newDialogSearch: false,
      formDatas: {},
      updateParameterDialog: false,
      updateQrcodeDialog: false,
      uform: {
        productNoStart: '',
        productNoEnd: '',
        materialModel: '',
        batchNo: '',
        produceDate: '',
        expiryDate: ''
      },
      qform: {
        productNo: '',
        newServeCode: ''
      },
      errorVisible: false,
      infoTitle: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    initData() {
      this.searchAll(
        this.currentPage,
        this.limit,
        '/inventory/listData',
        '&materialId=',
        '',
        '&selectedOpIds=',
        '',
        '&uid=',
        this.a_acount,
        '&value=',
        this.search,
        '&pageType=',
        '1'
      ).then(res => {
        console.log(res)

        if (res.status === 200) {
          this.loading = false
          this.tableData = res.data.object.list
          this.getDataList(res.data.object.total)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    selectionChangeHandle(selection) {
      console.log(selection)
      this.mark = 0
      this.numberSize = selection.length
      for (let i = 0; i < selection.length; i++) {
        this.tableDataSelections.push(selection[i].opId)
      }
      if (selection.length > 0) {
        this.defaultColr = 'primary'
        this.btnStatu = false
      }
    },

    // table column 的方法，改写这个方法
    filterTag(value, row, column) {
      return true
    },
    getDataList(total) {
      this.total = total
    },
    handleCurrentChange(val) {
      this.loading = true
      this.currentPage = val
      const formData = {
        pageNow: this.currentPage,
        pageSize: this.limit,
        uid: this.a_acount,
        pageType: '1',
        ...this.formDatas
      }
      searchParent.searchUpForm('/inventory/listData', formData).then(res => {
        if (res.status === 200) {
          this.loading = false
          this.tableData = res.data.object.list
          this.getDataList(res.data.object.total)
          this.newDialogSearch = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    fnFilterChangeInit(filter) {
      console.log(filter)
      // const arr = []
      // for (let i = 0; i < this.tableData.length; i++) {
      //   if (this.tableData[i].p_model === filter.p_model[0]) {
      //     arr.push(this.tableData[i])
      //   }
      // }
      // this.tableData = arr
      // this.getDataList()
      var materialId = ''
      if (filter.p_model !== undefined) {
        if (filter.p_model[0] !== undefined) {
          materialId = filter.p_model[0]
        }
      }
      this.loading = true
      this.searchAll(
        1,
        this.limit,
        '/inventory/listData',
        '&materialId=',
        materialId,
        '&selectedOpIds=',
        '',
        '&uid=',
        this.a_acount,
        '&value=',
        this.search,
        '&pageType=',
        '1'
      ).then(res => {
        if (res.status === 200) {
          this.loading = false
          this.tableData = res.data.object.list
          this.getDataList(res.data.object.total)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    getRowKey(row) {
      return row.opId
    },
    loseContro(row) {
      this.dialogVisible = true
      this.getId = row.opId
    },
    breakPro() {
      this.loading = true
      this.productDone(this.getId, '', '', '/inventory/dismantle').then(res => {
        if (res.data.code === 200) {
          this.initData()
          this.$refs.filterTable.clearSelection()
          this.$notify({
            title: '状态',
            message: '产品拆解成功',
            position: 'top-right',
            duration: 2000
          })
          this.dialogVisible = false
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    scrap(row) {
      if (row.scrapStatus === 0) {
        this.$notify({
          title: '提示',
          message: '该产品已经报废',
          position: 'top-right',
          duration: 2000
        })
        return false;
      }
      this.scrapDialogVisible = true
      this.getId = row.opId
    },
    twoScrap() {
      this.scrapDialogVisible = false
      this.twoScrapDialogVisible = true
    },
    twoScrapDialogClose() {
      this.twoScrapDialogVisible = false
    },
    execScrap() {
      this.loading = true
      const fd = new FormData()
      fd.append('opId', this.getId)
      fd.append('scrapStatus', 0) // 传参数
      axios.put('/inventory/updateScrapStatus', fd).then(res => {
        if (res.data.code === 200) {
          this.initData()
          this.$refs.filterTable.clearSelection()
          this.$notify({
            title: '状态',
            message: '产品报废成功',
            position: 'top-right',
            duration: 2000
          })
          this.twoScrapDialogVisible = false
        }
      })
    },
    scrapDialogClose() {
      this.scrapDialogVisible = false
    },
    recovery(row) {
      if (row.scrapStatus === 1) {
        this.$notify({
          title: '提示',
          message: '该产品已经恢复',
          position: 'top-right',
          duration: 2000
        })
        return false;
      }
      this.recoveryDialogVisible = true
      this.getId = row.opId
    },
    execRecovery() {
      this.loading = true
      const fd = new FormData()
      fd.append('opId', this.getId)
      fd.append('scrapStatus', 1) // 传参数
      axios.put('/inventory/updateScrapStatus', fd).then(res => {
        if (res.data.code === 200) {
          this.initData()
          this.$refs.filterTable.clearSelection()
          this.$notify({
            title: '状态',
            message: '产品恢复成功',
            position: 'top-right',
            duration: 2000
          })
          this.recoveryDialogVisible = false
        }
      })
    },
    recoveryDialogClose() {
      this.recoveryDialogVisible = false
    },
    loseData() {
      this.defaultColr = 'info'
      this.btnStatu = true
      const ids = this.tableDataSelections.join(',')
      console.log(this.mark)
      if (this.mark === 0) {
        this.loading = true
        this.mark++
        this.productDone(ids, '', '', '/inventory/dismantle').then(res => {
          if (res.data.code === 200) {
            this.initData()
            this.$refs.filterTable.clearSelection()
            this.$notify({
              title: '状态',
              message: '产品拆解成功',
              position: 'top-right',
              duration: 2000
            })
          }
        })
      }

      console.log('多个拆解')
    },
    searchEnterFun() {
      this.loading = true
      this.searchAll(
        1,
        this.limit,
        '/inventory/listData',
        '&materialId=',
        '',
        '&selectedOpIds=',
        '',
        '&uid=',
        this.a_acount,
        '&value=',
        this.search,
        '&pageType=',
        '1'
      ).then(res => {
        if (res.status === 200) {
          this.loading = false
          this.tableData = res.data.object.list
          this.getDataList(res.data.object.total)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    getType() {
      this.getSums('/material/listAboutSelf').then(res => {
        for (let i = 0; i < res.data.object.length; i++) {
          this.materialModelGroup.push({
            text: res.data.object[i].materialModel,
            value: res.data.object[i].id
          })
        }
      })
    },
    getAcounts() {
      this.getSums('/user/selfAndChild').then(res => {
        for (let i = 0; i < res.data.object.length; i++) {
          this.acounts.push({
            label: res.data.object[i].username,
            value: res.data.object[i].id
          })
        }
        this.a_acount = res.data.object[0].id
        this.initData()
      })
    },
    acountChange(val) {
      this.loading = true
      this.a_acount = val
      this.initData()
    },
    initBtn() {
      const btnArr = JSON.parse(this.$route.query.btnRight)
      console.log(btnArr)

      btnArr.forEach(item => {
        if (item.rightName === '查询') {
          this.s_show = true
        } else if (item.rightName === '导出') {
          this.e_show = true
        } else if (item.rightName === '拆解') {
          this.b_show = true
        } else if (item.rightName === '参数修改') {
          this.u_show = true
        } else if (item.rightName === '二维码修改') {
          this.q_show = true
        } else if (item.rightName === '报废') {
          this.y_show = true
        } else if (item.rightName === '恢复') {
          this.x_show = true
        }
      })
    },
    exportClientInfoExcel() {
      const ids = this.tableDataSelections.join(',')
      const that = this
      const loading = that.$loading({
        lock: true,
        text: '正在导出,请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.exportCompanyExcel(
        { opIds: ids, sortStr: this.keyName + ' ' + this.orderStatu },
        '/inventory/export'
      ).then(response => {
        if (response.status === 200) {
          loading.close()
          this.$refs.filterTable.clearSelection()
          that.downloadFile(response.data, '库存数据导出')
        }
      })
    },
    exportAllExcel() {
      const that = this
      const loading = that.$loading({
        lock: true,
        text: '正在导出,请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.exportCompanyExcel(
        {
          uid: that.a_acount,
          value: that.search,
          sortStr: that.keyName + ' ' + that.orderStatu,
          ...that.formDatas
        },
        '/inventory/exportInAll'
      ).then(response => {
        if (response.status === 200) {
          loading.close()
          that.downloadFile(response.data, '库存数据导出')
        }
      })
    },
    sortChange(column, prop, order) {
      console.log(column.prop) // prop标签 => nickname
      console.log(column.order) // descending降序、ascending升序
      const key = column.order.split('ending')[0]
      console.log(key)
      this.keyStatu = column.order
      this.orderStatu = key
      this.keyName = column.prop
      this.$refs.filterTable.clearSort()
      this.loading = true
      const formData = {
        pageNow: this.currentPage,
        pageSize: this.limit,
        uid: this.a_acount,
        pageType: '1',
        sortStr: this.keyName + ' ' + this.orderStatu,
        ...this.formDatas
      }
      searchParent.searchUpForm('/inventory/listData', formData).then(res => {
        if (res.status === 200) {
          this.loading = false
          this.tableData = res.data.object.list
          this.getDataList(res.data.object.total)
          this.newDialogSearch = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    handleTheadAddClass({ row, column, rowIndex, columnIndex }) {
      // 判断找到当前列 添加样式
      if (column.property === this.keyName) {
        return this.keyStatu
      }
    },
    searchMore() {
      this.newDialogSearch = true
    },
    updateParameter() {
      this.updateParameterDialog = true
    },
    updateQrCode() {
      this.updateQrcodeDialog = true
    },
    clearUpdateDialog() {
      this.uform = {
        productNoStart: '',
        productNoEnd: '',
        materialModel: '',
        batchNo: '',
        produceDate: '',
        expiryDate: ''
      }
    },
    clearUpdateQrCodeDialog() {
      this.qform = {
        productNo: '',
        newServeCode: ''
      }
    },
    sureUpdateParameter() {
      if (this.uform.productNoStart === '' || this.uform.productNoEnd === '') {
        this.errorVisible = true;
        this.infoTitle = '必须填写需要修改的产品序列号范围';
        return false
      }
      if (this.uform.materialModel === '' && this.uform.batchNo === '' && this.uform.produceDate === '' && this.uform.expiryDate === '') {
        this.errorVisible = true;
        this.infoTitle = '需要修改的内容不可全部为空'
        return false
      }
      this.dataChange(this.uform, '/inventory/updateProParam').then(res => {
        console.log(res.data.object)
        if (res.data.code === 200) {
          this.updateParameterDialog = false
          this.clearUpdateDialog()
          this.initData()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    sureUpdateQrCode() {
      if (this.qform.productNo === '' || this.uform.newServeCode === '') {
        this.errorVisible = true;
        this.infoTitle = '必须填写修改前和修改后的二维码';
        return false;
      }
      this.dataChange(this.qform, '/inventory/updateProServeCode').then(res => {
        console.log(res.data.object)
        if (res.data.code === 200) {
          this.updateQrcodeDialog = false
          this.clearUpdateQrCodeDialog()
          this.initData()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    },
    formClose() {
      this.newDialogSearch = false
    },
    parentDoFun(datas) {
      this.formDatas = datas
      const formData = {
        pageNow: this.currentPage,
        pageSize: this.limit,
        sortStr: this.keyName + ' ' + this.orderStatu,
        uid: this.a_acount,
        pageType: '1',
        ...datas
      }
      console.log(formData)
      this.loading = true
      searchParent.searchUpForm('/inventory/listData', formData).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.loading = false
          this.tableData = res.data.object.list
          this.getDataList(res.data.object.total)
          this.newDialogSearch = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getType()
    this.getAcounts()
    this.initBtn()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.container {
  margin: 25px 30px;
  width: 97%;
  background-color: #fff;
}

.loseContro {
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: rgba(30, 114, 247, 1);
  cursor: pointer;
}
.t_header {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  margin-bottom: 10px;
}
</style>
